function scriptTrigger(){
  document.addEventListener("cart:change", (event) => {
    let fetchCart = event.detail["cart"];
    let item_count = fetchCart.item_count;
    if(document.querySelector('.header-cart-icon')) {
      if(item_count == 0) {
        document.querySelector('.header-cart-icon').classList.add('hidden');
      } else {
        document.querySelector('.header-cart-icon').classList.remove('hidden');
      }
    }
  });
  
  // Sticky Button
  var stickyButton = document.getElementById( 'sticky-button' );
  window.addEventListener('scroll', function () {
    if ( window.pageYOffset > 300 ) {
      stickyButton.style.display = "block";
    } else {
      stickyButton.style.display = "none";
    }
  });
}
scriptTrigger();
document.addEventListener("shopify:section:load", scriptTrigger);
document.addEventListener("shopify:section:unload", scriptTrigger);